<script>
import { mapState } from 'vuex';
import Attr from './Attr.vue';
import ArtworkImage from './ArtworkImage.vue';
import ArtworkSidebarAccordion from './ArtworkSidebarAccordion.vue';
import ArtworkSidebarPreviewImage from './ArtworkSidebarPreviewImage.vue';
import artworkDetailsMixin from 'mixins/artworkDetailsMixin.js';
import TextNoteExtract from './TextNoteExtract.vue';

import applyHighlights from 'lib/applyHighlights.js';
import { partialStrings, unavailableImage } from 'config';
import template from '../../views/partials/single/artwork_element.html';

export default {
  data() {
    return {
      partial: partialStrings,
    };
  },
  components: {
    Attr,
    ArtworkImage,
    ArtworkSidebarAccordion,
    ArtworkSidebarPreviewImage,
    TextNoteExtract,
  },
  mixins: [artworkDetailsMixin],
  template,
  props: ['artwork', 'index', 'rawArtwork'],
  computed: {
    ...mapState('artworks', ['images', 'currentImage']),
    ...mapState('artworks', { artworkHeader: 'artwork' }),
    artistNotes() {
      return this.notes ? this.notes.artist : [];
    },
    artworkNotes() {
      return this.notes ? this.notes.artwork : [];
    },
    cartNotes() {
      return this.notes ? this.notes.cart : [];
    },
    isImageNotAvailable() {
      return this.artwork.image_unavailable;
    },
    imageNotAvailable() {
      return unavailableImage.main[this.artwork.image_unavailable];
    },
    isAuthorInCommon() {
      const { author_in_common, recap_multi } = this.artwork;
      return author_in_common != 'a' || recap_multi != 'yes';
    },
    scopedImages() {
      const { index } = this.$route.query;
      if (index == this.index) {
        return this.images;
      } else {
        return this.artwork?.imageSet?.images;
      }
    },
    highlightedImages() {
      if (!this.artworkHeader.highlights) return this.scopedImages;
      return this.scopedImages.map((i) => applyHighlights(i, this.artworkHeader.highlights));
    },
    image() {
      const index = this.currentImage || 0;
      return (this.highlightedImages && this.highlightedImages[index]) || {};
    },
  },
  methods: {
    isNoteAvailable({ author_in_common, recap_multi }) {
      return author_in_common != 'a' || recap_multi != 'yes';
    },
    setElement() {
      this.$emit('setCurrent');
    },
  },
};
</script>
